import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSearch, FiX } from 'react-icons/fi';
import { useSearch } from '../../context/SearchContext';

const SearchBar = ({ onClose }) => {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const { performSearch, getSuggestions } = useSearch();
  const navigate = useNavigate();

  useEffect(() => {
    if (query.length > 1) {
      setSuggestions(getSuggestions(query));
    } else {
      setSuggestions([]);
    }
  }, [query, getSuggestions]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      performSearch(query);
      navigate('/search');
      onClose && onClose();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setQuery(suggestion);
    performSearch(suggestion);
    navigate('/search');
    onClose && onClose();
  };

  return (
    <div className="relative">
      <form onSubmit={handleSubmit} className="flex items-center bg-gray-100 rounded-lg overflow-hidden">
        <FiSearch className="ml-4 text-gray-400" size={20} />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search for products, categories..."
          className="flex-1 px-4 py-3 bg-transparent outline-none text-sm"
          autoFocus
        />
        {query && (
          <button type="button" onClick={() => setQuery('')} className="p-2 mr-2">
            <FiX size={18} className="text-gray-400" />
          </button>
        )}
      </form>

      {/* Suggestions Dropdown */}
      {suggestions.length > 0 && (
        <div className="absolute top-full left-0 right-0 bg-white border rounded-lg mt-1 shadow-lg z-50">
          {suggestions.map((suggestion, index) => (
            <button
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 transition-colors"
            >
              <FiSearch className="inline mr-2 text-gray-400" size={14} />
              {suggestion}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
